export const SITE_TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'performance', label: 'Performance' },
  { key: 'ssl', label: 'SSL' },
  { key: 'seo', label: 'SEO (Lighthouse)' },
  { key: 'seo-report', label: 'SEO Report' },
  { key: 'security', label: 'Security' },
  { key: 'plugins', label: 'Plugins' },
  { key: 'sitescan', label: 'Site Scan' },
  { key: 'history', label: 'History' },
];

export const SITE_TAB_KEYS = SITE_TABS.map((t) => t.key);
